/* ============================================================
   BusterPro Collection Page
   View toggle · Filter accordion · Mobile drawers · Custom sort
   ============================================================ */

(function () {
  'use strict';

  /* ── View toggle (grid / list) ── */

  var grid        = document.getElementById('bp-coll-products');
  var viewBtns    = document.querySelectorAll('.bp-coll-view-btn');
  var STORAGE_KEY = 'bp-coll-view';

  function setView(view) {
    if (!grid) return;
    grid.setAttribute('data-view', view);

    viewBtns.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-view') === view);
    });
  }

  (function initView() {
    var defaultView = (grid && grid.getAttribute('data-default-view')) || 'grid';
    setView(defaultView);
  }());

  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setView(btn.getAttribute('data-view'));
    });
  });

  /* ── Filter form auto-submit on checkbox change ── */

  var filterForm = document.getElementById('bp-filter-form');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') {
        filterForm.submit();
      }
    });
  }

  /* ── Filter accordion ── */

  document.querySelectorAll('.bp-coll-filter-heading').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group  = btn.closest('.bp-coll-filter-group');
      var isOpen = group.getAttribute('data-open') === 'true';
      group.setAttribute('data-open', isOpen ? 'false' : 'true');
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  /* ── Custom sort dropdown ── */

  var sortWrap     = document.getElementById('bp-sort-wrap');
  var sortTrigger  = document.getElementById('bp-sort-trigger');
  var sortDropdown = document.getElementById('bp-sort-dropdown');
  var sortCurrent  = document.getElementById('bp-sort-current');
  var sortSelect   = document.getElementById('bp-sort-select');

  function openSortDropdown() {
    if (!sortDropdown) return;
    sortDropdown.hidden = false;
    sortTrigger.setAttribute('aria-expanded', 'true');
  }

  function closeSortDropdown() {
    if (!sortDropdown) return;
    sortDropdown.hidden = true;
    if (sortTrigger) sortTrigger.setAttribute('aria-expanded', 'false');
  }

  if (sortTrigger) {
    sortTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = !sortDropdown.hidden;
      isOpen ? closeSortDropdown() : openSortDropdown();
    });
  }

  // Select a sort option
  if (sortDropdown) {
    sortDropdown.addEventListener('click', function (e) {
      var item = e.target.closest('.bp-sort-dropdown__item');
      if (!item) return;

      var value = item.getAttribute('data-value');

      // Update displayed label
      if (sortCurrent) sortCurrent.textContent = item.textContent.trim();

      // Update native select value and submit form
      if (sortSelect) {
        sortSelect.value = value;
      }

      // Update active state in dropdown
      sortDropdown.querySelectorAll('.bp-sort-dropdown__item').forEach(function (el) {
        el.classList.toggle('is-selected', el === item);
        el.setAttribute('aria-selected', el === item ? 'true' : 'false');
      });

      closeSortDropdown();

      // Update hidden field in filter form and submit
      if (filterForm) {
        var hidden = filterForm.querySelector('input[name="sort_by"]');
        if (hidden) hidden.value = value;
        filterForm.submit();
      } else {
        // Fallback: navigate directly
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.href = url.toString();
      }
    });
  }

  // Close dropdown on outside click
  document.addEventListener('click', function (e) {
    if (sortWrap && !sortWrap.contains(e.target)) {
      closeSortDropdown();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSortDropdown();
  });

  /* ── Mobile drawers ── */

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      var focusable = drawer.querySelector('button, input, a, select, [tabindex]:not([tabindex="-1"])');
      if (focusable) focusable.focus();
    });
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function wireDrawer(openId, closeId, backdropId, drawerId) {
    var openBtn  = document.getElementById(openId);
    var closeBtn = document.getElementById(closeId);
    var backdrop = document.getElementById(backdropId);
    var drawer   = document.getElementById(drawerId);
    if (!drawer) return;
    if (openBtn)  openBtn.addEventListener('click',  function () { openDrawer(drawer); });
    if (closeBtn) closeBtn.addEventListener('click', function () { closeDrawer(drawer); });
    if (backdrop) backdrop.addEventListener('click', function () { closeDrawer(drawer); });
  }

  wireDrawer('bp-filter-open', 'bp-filter-close', 'bp-filter-backdrop', 'bp-filter-drawer');
  wireDrawer('bp-sort-open',   'bp-sort-close',   'bp-sort-backdrop',   'bp-sort-drawer');

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    ['bp-filter-drawer', 'bp-sort-drawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.getAttribute('aria-hidden') === 'false') closeDrawer(el);
    });
  });

  /* ── Mobile filter form: keep sort_by in sync with custom dropdown ── */

  var mobileFilterForm = document.getElementById('bp-mobile-filter-form');
  if (mobileFilterForm && sortSelect) {
    sortSelect.addEventListener('change', function () {
      var hidden = mobileFilterForm.querySelector('input[name="sort_by"]');
      if (hidden) hidden.value = sortSelect.value;
    });
  }

}());
